import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar, ListOrdered, User } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/home',     label: 'Home',     Icon: Calendar,     testId: 'nav-home-button' },
  { path: '/bookings', label: 'Bookings', Icon: ListOrdered,  testId: 'nav-bookings-button' },
  { path: '/profile',  label: 'Profile',  Icon: User,         testId: 'nav-profile-button' },
];

export default function BottomNav() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="bottom-nav">
      <div className="max-w-md mx-auto flex justify-around items-center py-3 px-6">
        {NAV_ITEMS.map(({ path, label, Icon, testId }) => {
          const active = pathname === path || pathname.startsWith(path + '/');
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              data-testid={testId}
              aria-label={label}
              aria-current={active ? 'page' : undefined}
              className={`flex flex-col items-center gap-0.5 transition-colors min-w-[48px] py-1 ${
                active ? 'text-primary' : 'text-muted-foreground hover:text-primary'
              }`}
            >
              <Icon className={`w-6 h-6 ${active ? 'stroke-[2.5]' : ''}`} />
              <span className={`text-[10px] font-bold uppercase tracking-wide ${active ? 'text-primary' : ''}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
